export default __webpack_public_path__ + "img/rzd.ac124759.svg";